import DateFormat from '@/Enums/Format/DateFormat.enum';
import {
  ICreateDV360TicketsLineItemPayload,
  IDV360TicketsLineItem,
  IDV360TicketsLineItemForm,
  IDuplicateDV360TicketsLineItemForm,
  IDuplicateDV360TicketsLineItemPayload,
  IUpdateDV360TicketsLineItemPayload,
} from '@/Interfaces/DV360Tickets/LineItem.interface';
import AudienceTargetingService from '@/Services/AudienceTargeting.service';
import { LINE_ITEM_DEFAULT_GEO } from '@/constants/campaignManagement';
import { mapLineItemCreativesToFormStructure } from '@/helpers/campaignManagement';
import moment from 'moment';

export const dv360TicketsLineItemToFormStructure = (lineItem: IDV360TicketsLineItem): IDV360TicketsLineItemForm => {
  const {
    id,
    name,
    budget,
    bid_cpm: bidCpm,
    geo,
    geo_fence,
    product,
    daypart,
    audienceMeta: audiencesMeta,
    creatives,
    start_date: startDate,
    end_date: endDate,
    alt_id: altId,
  } = lineItem;

  return {
    id,
    name,
    budget: budget == null ? null : String(budget),
    bidCpm: bidCpm == null ? null : String(bidCpm),
    geo: geo ?? LINE_ITEM_DEFAULT_GEO,
    geoFence: geo_fence ?? null,
    audiences: AudienceTargetingService.audienceMetaTargetingToAudienceControlOptionTargeting(audiencesMeta),
    product,
    daypart,
    creatives: mapLineItemCreativesToFormStructure(creatives),
    startDate: moment.utc(startDate),
    endDate: moment.utc(endDate),
    altId,
  };
};

export const dv360TicketsLineItemsFormToApiCreate = (
  insertionOrderId: number,
  {
    budget,
    bidCpm,
    startDate,
    endDate,
    product,
    audiences,
    altId,
    creatives,
    geoFence,
    geo,
    ...restData
  }: IDV360TicketsLineItemForm,
): ICreateDV360TicketsLineItemPayload => {
  return {
    insertionOrderId,
    budget: Number(budget ?? 0),
    ...(bidCpm !== null && bidCpm !== undefined && bidCpm !== '' && { bidCpm: Number(bidCpm) }),
    startDate: moment.utc(startDate).format(DateFormat.Iso8601),
    endDate: moment.utc(endDate).format(DateFormat.Iso8601),
    productId: product?.id,
    audiences: AudienceTargetingService.audienceControlOptionsToTargeting(audiences),
    altId,
    creatives: creatives.filter(({ disassociated }) => !disassociated),
    geoFence: geoFence || null,
    geo: geoFence ? undefined : geo,
    ...restData,
  };
};

export const dv360TicketsLineItemsFormToApiUpdate = (
  insertionOrderId: number,
  {
    budget,
    bidCpm,
    startDate,
    endDate,
    product,
    audiences,
    altId,
    creatives,
    id,
    geoFence,
    geo,
    ...restData
  }: IDV360TicketsLineItemForm,
): IUpdateDV360TicketsLineItemPayload => {
  return {
    insertionOrderId,
    ...(budget !== null && budget !== undefined && budget !== '' && { budget: Number(budget) }),
    ...(bidCpm !== null && bidCpm !== undefined && bidCpm !== '' && { bidCpm: Number(bidCpm) }),
    ...(startDate && { startDate: moment.utc(startDate).format(DateFormat.Iso8601) }),
    ...(endDate && { endDate: moment.utc(endDate).format(DateFormat.Iso8601) }),
    ...(product && { productId: product.id }),
    ...(audiences && { audiences: AudienceTargetingService.audienceControlOptionsToTargeting(audiences) }),
    ...(altId !== undefined && { altId }),
    ...(creatives && { creatives: creatives.filter(({ disassociated }) => !disassociated) }),
    ...(id !== null && id !== undefined && { id: Number(id) }),
    ...(geoFence !== undefined && { geoFence: geoFence || null }),
    ...(geo !== undefined && { geo: geoFence ? undefined : geo }),
    ...restData,
  };
};

export const dv360lineItemsFormToApiDuplicate = ({
  budget,
  startDate,
  endDate,
  product,
  ...restData
}: IDuplicateDV360TicketsLineItemForm): IDuplicateDV360TicketsLineItemPayload => {
  return {
    budget: Number(budget ?? 0),
    startDate: moment.utc(startDate).format(DateFormat.Iso8601),
    endDate: moment.utc(endDate).format(DateFormat.Iso8601),
    productId: product!.id,
    ...restData,
  };
};
